import { DEFAULT_THEME_ID, THEME_PRESETS } from './themes.js';

export function applyTheme({ presetId, accent } = {}) {
  const preset = THEME_PRESETS[presetId] || THEME_PRESETS[DEFAULT_THEME_ID];
  const root = document.documentElement;

  // Set preset id for debugging / targeted tweaks
  root.dataset.theme = preset.id;

  for (const [key, value] of Object.entries(preset.vars)) {
    root.style.setProperty(key, value);
  }

  // Accent override (user custom)
  if (accent) {
    root.style.setProperty('--accent', accent);
  }
}
